import { Component, Inject, Optional, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DtoProductsVM } from '../../../Model/price-list/DtoProductsVM';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { SharedService } from '../../../Shared/Services/shared.service';
import { OrderInfoVM } from '../../../Model/orders/OrderInfoVM';

@Component({
  selector: 'app-add-order-pricing',
  templateUrl: './add-order-pricing.component.html',
  styleUrl: './add-order-pricing.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AddOrderPricingComponent {
  dataRes: any = {};
  productData: DtoProductsVM;
  OnlyQuantity: boolean = false;
  PricingForm!: FormGroup;
  constructor(
    public dialogRef: MatDialogRef<AddOrderPricingComponent>, private auth: AuthService, private shared: SharedService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: DtoProductsVM, private router: Router) {
    this.dataRes = data;
    this.productData = this.dataRes?.data?.productData;
    this.OnlyQuantity = this.dataRes?.data?.OnlyQuantity
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.Workshop, UserType.Agent])) {
      this.initForm();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  get f() {
    return this.PricingForm.controls;
  }

  initForm() {
    if (this.OnlyQuantity) {
      this.PricingForm = new FormGroup({
        Quantity: new FormControl('', [Validators.required])
      });
    }
    else {
      this.PricingForm = new FormGroup({
        Quantity: new FormControl('', [Validators.required]),
        IronQuantity: new FormControl('', [Validators.required])
      });
    }
  }

  Cancel() {
    this.dialogRef.close();
  }

  Save(form?: any) {
    if (form.valid) {
      const data: OrderInfoVM = {
        numRollsUsed: form.value.Quantity,
        numIronUsed: form.value.IronQuantity
      };

      this.dialogRef.close({ data: data, productData: this.productData });
    }
    else {
      this.shared.FireFormValidation(form);
    }
  }
}
